export const FileUploadItem = {
	key: "imageUrl",
	label: "CDN Dosyası",
	fileSize: "5242880",
	fileSizeText: "Max 5MB",
	format: "JPEG, JPG, PNG"
};